import React from "react";
import uuid from "uuid";
import { Slide } from "./Slide";
import { ScrollPage } from "./ScrollPage";
import { Flex, Text, Box } from "rebass";
import { Hr } from "./Primitives";

const getActiveIndex = function(scrollTop, nItems) {
  return Math.floor((nItems - 1) * (scrollTop + 0.001));
};

export const SlideScroller = ({ projects, ...props }) => {
  const nSlides = projects.length;
  const renderUI = (scrollTop, setVerticalScroll) => {
    const activeIndex = getActiveIndex(scrollTop, nSlides);
    return (
      <Flex
        width="1rem"
        flexDirection="column"
        justifyContent="space-around"
        css="
          position: absolute;
          top: 0;
          bottom: 0;
          right: 0;
        "
      >
        {projects.map((c, i) => (
          <Box
            css={{
              position: "relative",
              zIndex: 50
            }}
            key={uuid()}
          >
            <Text
              css={{
                position: "absolute",
                right: "100%",
                top: "100%",
                transform: "translateY(-50%)",
                "&:hover": {
                  color: "#D2DEE7",
                  cursor: "pointer"
                }
              }}
              pr={1}
              fontFamily="proxima"
              fontSize="0"
              fontWeight={2}
              onClick={() => {
                setVerticalScroll(i / (nSlides - 1));
              }}
              color={activeIndex === i ? "active" : "inactive"}
            >
              0{i + 1}
            </Text>
            <Hr borderColor={c.color} />
          </Box>
        ))}
      </Flex>
    );
  };
  return (
    <ScrollPage renderUI={renderUI}>
      {projects.map(data => (
        <Slide key={uuid()} history={props.history} {...data} />
      ))}
    </ScrollPage>
  );
};

const defaultData = [
  {
    color: "accentBlue",
    cover: { src: "", alt: "" },
    title: "Loremium Ipsu ame",
    description:
      "Experiments with complex multi-layered animations and route transitions.",
    tag: "Never-Sleep",
    library: { npm: "styled-components", import: "styled" }
  },
  {
    color: "accentGreen",
    cover: { src: "", alt: "" },
    title: "Designing the code",
    description:
      "Experiments with complex multi-layered animations and route transitions.",
    tag: "self-Initiated",
    library: { npm: "react", import: "React" }
  }
];

SlideScroller.defaultProps = {
  projects: defaultData
};
